export default {
  name: 'cart',
  path: '/cart',
  meta: {
    auth: true
  },
  component: () => import('@/views/cart')
}



// WEBPACK FOOTER //
// ./src/router/routes/cart.js